// Primary navigation structure. Shared by the desktop MainNav and the
// mobile overlay so the two never drift. Map and Compare are plain links;
// About and Research are dropdown groups. About links to its own landing
// page; Research is a category label with no page of its own.
//
// The Participate group was removed in Sep 2026. No volunteer observation was
// ever collected (the rollup was an empty object and no CSV ever reached the
// server), so the section was parked until the volunteer programme is
// revisited. /participate, /contribute/observations and /campaigns still
// respond; they are simply no longer advertised here or in the sitemap.
// "Provide feedback" moved under About because expert review is a different
// activity and is still wanted.

export type NavLeaf = { label: string; href: string };
export type NavGroup = { label: string; href?: string; children: NavLeaf[] };
export type NavNode = NavLeaf | NavGroup;

export function isGroup(node: NavNode): node is NavGroup {
  return "children" in node;
}

export const NAV: NavNode[] = [
  { label: "Map", href: "/map" },
  { label: "Neighbourhoods", href: "/neighbourhoods" },
  { label: "Compare", href: "/compare" },
  {
    label: "About",
    href: "/about",
    children: [
      { label: "Glossary", href: "/glossary" },
      { label: "References", href: "/references" },
      { label: "Future work", href: "/future-work" },
      { label: "QA report", href: "/qa" },
      // Expert feedback is a different activity from volunteer data collection,
      // and is the part of the old Participate group that is NOT being parked.
      { label: "Provide feedback", href: "/expert-review" },
    ],
  },
  {
    label: "Research",
    children: [
      { label: "Insights", href: "/insights" },
      { label: "Findings", href: "/findings" },
      { label: "Blog", href: "/blog" },
      { label: "Methodology", href: "/methodology" },
      { label: "What the model misses", href: "/limitations/human-experience" },
      { label: "Data ethics", href: "/data-ethics" },
    ],
  },
];
